import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["main", "layout", "bgcolor"],
  _excluded2 = ["children", "className"];
let _ = t => t,
  _t,
  _t2;
import * as React from 'react';
import styled, { css } from 'styled-components';
import Box from '@mui/material/Box';
import { VarnishContext } from './VarnishContext';
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */

const contentCSS = css(_t || (_t = _`
  max-width: ${0};
  width: 100%;
  ${0}
  padding: ${0};

  // if the user passes a key to the color theme, use the mapped color,
  // else treat the string as a normal color string
  background: ${0};

  @media (max-width: ${0}) {
    padding: ${0};
  }
`), ({
  theme,
  layout
}) => layout === 'center-aligned' ? `${theme.breakpoints.values.lg}px` : null, ({
  layout
}) => layout === 'center-aligned' ? 'margin: 0 auto;' : '', ({
  theme
}) => theme.spacing(3), ({
  theme,
  bgcolor
}) => bgcolor ? theme.color[bgcolor] ? theme.color[bgcolor] : bgcolor : 'none', ({
  theme
}) => `${theme.breakpoints.values.sm}px`, ({
  theme
}) => theme.spacing(1.5));
const InternalContent = styled(_ref => {
  let {
      main
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Box, _extends({
    component: main ? 'main' : 'div'
  }, rest));
})(_t2 || (_t2 = _`
  ${0}
`), contentCSS);
export function Content(_ref2) {
  let {
      children,
      className
    } = _ref2,
    basicProps = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(VarnishContext.Consumer, {
    children: ({
      layout
    }) => /*#__PURE__*/_jsx(InternalContent, _extends({
      layout: layout,
      className: className
    }, basicProps, {
      children: children
    }))
  });
}
export default Content;